import React from 'react';

import {KeyboardArrowUp} from "../../icons/keyboard-arrow/keyboard-arrow-up";
import {KeyboardArrowDown} from "../../icons/keyboard-arrow/keyboard-arrow-down";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {AppTerms} from "../../app/app-terms";
import {ExpandableFooterShowMoreButtonComposer} from "./expandable-footer-show-more-button.composer";
import {WithTerms} from "../composers/with-terms";
import styles from "./expandable-footer.module.scss";
import classNames from "classnames";

export class ExpandableFooterShowMoreButtonComponentProps extends BaseProps {
  onClick: Function;
  expanded: Boolean;
  hideArrow: Boolean;
  i18n: AppTerms;
}

export const ExpandableFooterShowMoreButton = WithTerms(ExpandableFooterShowMoreButtonComposer()((props: ExpandableFooterShowMoreButtonComponentProps) => {
  return (
    <div onClick={(e) => props.onClick(e)} className={classNames(styles.show_more_button_container)}>
      {
        props.expanded ? props.i18n.SEE_LESS : props.i18n.SEE_MORE
      }
      {
        !props.hideArrow ? (props.expanded ? <KeyboardArrowUp className={classNames(styles.show_more_button_arrow)}/> :
          <KeyboardArrowDown className={classNames(styles.show_more_button_arrow)}/>) : null
      }
    </div>
  )
}));
